import { render, staticRenderFns } from "./MarketingConsentOverview.vue?vue&type=template&id=d0ea5b7c&scoped=true&"
import script from "./MarketingConsentOverview.vue?vue&type=script&lang=js&"
export * from "./MarketingConsentOverview.vue?vue&type=script&lang=js&"
import style0 from "./MarketingConsentOverview.vue?vue&type=style&index=0&id=d0ea5b7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ea5b7c",
  null
  
)

export default component.exports